module.exports = __webpack_public_path__ + "9779d9a1/img/comments-icon.fdec7fdb.svg";